import { getArkosConfig } from "../../../../server";
import { capitalize } from "../../../../utils/helpers/text.helpers";

export default function getSwaggerDefaultConfig(
  defaultModelsPaths: Record<string, any>
) {
  const portAndHost = {
    port: process.env.__PORT || process.env.PORT || "8000",
    host: process.env.__HOST! || process.env.HOST || "127.0.0.1",
  };
  const config = getArkosConfig();

  return {
    endpoint: "/docs",
    mode: "prisma",
    strict: false,
    options: {
      definition: {
        openapi: "3.1.0",
        info: {
          title: "Powered By Arkos.js",
          version: "1.0.0",
          description:
            "This API was automatically generated by Arkos.js, read more about at www.arkosjs.com",
        },
        servers: [
          {
            url: `http://${["0.0.0.0", "localhost", "127.0.0.1"].includes(portAndHost.host!) ? "localhost" : portAndHost.host}:${portAndHost.port}`,
            description: `Local ${capitalize(process.env.NODE_ENV || "development")} Server`,
          },
        ],
        paths: defaultModelsPaths,
        components: {
          securitySchemes: {
            BearerAuth: {
              type: "http",
              scheme: "bearer",
              bearerFormat: "JWT",
            },
          },
        },
        security: [],
      },
      apis: ["./src/**/*.router.{ts,js}", "./src/**/*.route.{ts,js}"],
      deepLinking: true,
      tryItOutEnabled: true,
      persistAuthorization: false,
    },
    scalarApiReferenceConfiguration: {
      theme: "deepSpace",
      darkMode: true,
      layout: "modern",
      showSidebar: true,
      hideDownloadButton: false,
      cdn: config.globalPrefix + "/scalar-api-reference/browser/standalone.js",
      metaData: {
        title: "Arkos.js API Documentation",
        description: "API documentation generated by Arkos.js",
      },
      pageTitle: "Arkos.js API Documentation",
      customCss: `.scalar-client {
width: 100vw !important;
height: 100vh !important;
max-width: 100vw !important;
max-height: 100vh !important;
top: 0 !important;
left: 0 !important;
transform: none !important;
border-radius: 0 !important;
}`,
    },
  };
}
